<section class="event-landing-page">
  <div class="event-landing-page__shell">
    <p *ngIf="isLoading" class="event-landing-page__status" role="status">
      Loading event details…
    </p>

    <section
      *ngIf="isUnavailable"
      class="event-landing-page__unavailable"
      aria-labelledby="event-unavailable-title"
    >
      <h1 id="event-unavailable-title">This event page is unavailable</h1>
      <p>The event may be unpublished, disabled, or no longer available.</p>
      <a class="btn btn-black" routerLink="/events">Browse events</a>
    </section>

    <app-event-landing-banner
      *ngIf="displayPage as visiblePage"
      [page]="visiblePage"
      [countdown]="countdown"
      [ctaMode]="ctaMode"
      [rsvpRoute]="rsvpRoute"
      [rsvpQueryParams]="{ autoRSVP: true }"
      [rsvpReturnUrl]="rsvpReturnUrl"
      (share)="openShareModal()"
    ></app-event-landing-banner>
  </div>
</section>

<app-share-modal #shareModal [currentUrl]="canonicalUrl"></app-share-modal>
